import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/flowable/process-detail.vue'
wx.createPage(MiniProgramPage)